import * as _ from "lodash";
import * as angular from "angular";
import { InviteDataProvider } from "../../data-provider/invite.dp";
import { Invite } from "../../models/invite.model";
import { Team } from "../../models/team.model";
import { User } from "../../models/user.model";
import { DialogUtils } from "../../helper/dialog.helper";
import { ToastUtils } from "../../helper/toast.helper";
import { TeamColorDataProvider } from "../../data-provider/team-color.dp";
import { TeamDataProvider } from "../../data-provider/team.dp";

let TeamForm = {
    selector: "vcTeamForm",
    templateUrl: "/angular/components/team/team-form.component.html",
    bindings: {
        selectedTeam: "=?",
        hideUsers: "=",
    },
    controller: class TeamFormController {
        // * bindings for typescript compiler *
        public selectedTeam?: Team;
        public hideUsers: any;
        // ************************************

        public colors: string[];
        public editTeam: Team;
        public selectedUsers: User[] = [];
        public invites: Invite[] = [];
        private originalUids: any[] = [];
        private originalInviteIds: any[] = [];

        private readonly modelsUtils: any;
        private readonly dialog: DialogUtils;
        private readonly toast: ToastUtils;
        private dataProvider: TeamDataProvider;

        constructor(
            DialogUtils: DialogUtils,
            ToastUtils: ToastUtils,
            ModelsUtils: any,
            TeamDataProvider: TeamDataProvider,
            TeamColorDataProvider: TeamColorDataProvider,
            InviteDataProvider: InviteDataProvider
        ) {
            this.dialog = DialogUtils;
            this.toast = ToastUtils;
            this.modelsUtils = ModelsUtils;
            this.dataProvider = TeamDataProvider;

            this.colors = TeamColorDataProvider.teamColours;

            InviteDataProvider.all().then((invites: Invite[]) => {
                this.invites = invites;
            });
        }

        $onInit(): void {
            this.editTeam = this.modelsUtils.team(this.selectedTeam);
            this.selectedUsers = _.cloneDeep(this.editTeam.users);
            angular.forEach(this.editTeam.invites, (invite: any) => {
                this.selectedUsers.push(invite);
            });
            // What this dialog loaded, so a save only applies the changes made
            // here and keeps members added elsewhere since it was opened.
            this.originalUids = this.getSelectedUsers(this.selectedUsers).map(
                (user: User) => user.uid
            );
            this.originalInviteIds = this.getSelectedInvites(
                this.selectedUsers
            ).map((invite: any) => invite.campaigninviteid);
        }

        removeUser(user: User, users: User[]): void {
            angular.forEach(users, (thisUser: User, $index: number) => {
                if (user.uid && user.uid == thisUser.uid) {
                    users.splice($index, 1);
                } else if (
                    user.campaigninviteemail &&
                    user.campaigninviteemail == thisUser.campaigninviteemail
                ) {
                    users.splice($index, 1);
                } else if (
                    user.campaigninvitephonenumber &&
                    user.campaigninvitephonenumber ==
                        thisUser.campaigninvitephonenumber &&
                    user.campaigninvitecountrycode ==
                        thisUser.campaigninvitecountrycode
                ) {
                    users.splice($index, 1);
                }
            });
        }

        setSelectedUsers(users: User[]): void {
            angular.forEach(users, (user: User) => {
                if (this.editTeam.hasMember(user)) {
                    this.selectedUsers.push(user);
                }
            });
        }

        saveTeam(team: Team): void {
            team.users = this.getSelectedUsers(this.selectedUsers);
            team.invites = this.getSelectedInvites(this.selectedUsers);
            if (team.tid) {
                team.original_uids = this.originalUids;
                team.original_invite_ids = this.originalInviteIds;
                this.dataProvider.updateTeam(team).then(
                    (saved: Team) => this.dialog.hide(saved),
                    () => this.toast.error()
                );
            } else {
                this.dataProvider.createTeam(team).then(
                    (saved: Team) => {
                        this.dialog.hide(saved);
                        this.toast.success("Team created");
                    },
                    () => this.toast.error()
                );
            }
        }

        getSelectedUsers(users: User[]): User[] {
            return users.filter((user: User) => user.uid);
        }

        getSelectedInvites(users: any): any {
            return users.filter((user: User) => {
                if (user.campaigninviteemail) {
                    return user.campaigninviteemail;
                } else if (user.campaigninvitephonenumber) {
                    return (
                        user.campaigninvitecountrycode +
                        user.campaigninvitephonenumber
                    );
                }
            });
        }

        selectColor(color: string): void {
            this.editTeam.tcolor = color;
        }

        ok(): void {
            this.saveTeam(this.editTeam);
        }

        cancel(): void {
            this.dialog.hide();
        }
    },
};

angular.module("team").component(TeamForm.selector, TeamForm);
